export const transformVariantInfoToArray = (variantInfo) => {
  const newVariantInfo = [];
  if(Object.keys(variantInfo).length === 0) return newVariantInfo;
  for (const key in variantInfo) {
    newVariantInfo.push({
      name: key,
      amount: variantInfo[key]?.amount,
      quantity: variantInfo[key]?.quantity || "",
      infiniteQuantity: variantInfo[key]?.infiniteQuantity || false,
      forMemberOnly: variantInfo[key]?.forMemberOnly,
      reserveProduct: variantInfo[key]?.reserveProduct || 0,  
      counterVariant: 0,
    })
  }
  return newVariantInfo;
}

export const transformVariantInfoToObject = (variantInfo) => {
  const newVariantInfo = {};
  if(variantInfo.length === 0) return newVariantInfo;
  variantInfo.forEach((item) => {
    if(item.counterVariant > 0) {
      newVariantInfo[item.name] = item?.counterVariant;
    }
  })
  return newVariantInfo;

}